export { default as FontistoIcon } from './component';
